import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import ErrorBoundary from '../ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "deviationsubmitpopup" */ './redux/ModuleLoadable')));
const LoadableDeviationSubmitPopup = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "deviationsubmitpopup" */ './DeviationSubmitPopup')));
const LazyDeviationSubmitPopup = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LazyDeviationSubmitPopup"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableDeviationSubmitPopup, props)));
LazyDeviationSubmitPopup.displayName = 'LazyDeviationSubmitPopup';
export default LazyDeviationSubmitPopup;
